export const isLoading = (state) => state.status === 'loading'
export const isLoaded = (state) => state.status === 'loaded'
export const isSuccess = (state) => state.status === 'loaded'
export const shouldLoad = (state) => state.status === 'idle' || state.status === 'error'
